import { useEffect, useRef, useState } from "react";
import "./PropertiesDetails.css";
import PropertySlider from "./PropertySlider";
import SimilarListings from "./SimilarListings";
import { Link, useNavigate, useParams } from "react-router-dom";
import { onApiCallBookingSend, onApiCallPropertyDetails, onApiCallPropertyNext, onApiCallPropertyPrev, onApiCallSubAmenities } from "../../Core/Apicall";
import ReCAPTCHA from "react-google-recaptcha";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import DynamicTimeSelect from "../../Components/DynamicTime/DynamicTime";
import { sitekey, UrlImage } from "../../Core/ApiEndPoint";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Box } from "lucide-react";
import VisitModal from "./VisitModal";


const PropertyDetails = () => {
  const { id } = useParams();
  const [profileData, setProfileData] = useState([]);
  const [subAmenities, setSubAmenities] = useState([]);
  const { i18n } = useTranslation();
  const [openPicker, setOpenPicker] = useState(false);
  const [value, setValue] = useState(null);

  const lang = i18n.language;

  const handleApiCallPropertyList = async () => {
    try {
      const data = `${id}?lang=${lang}`
      const response = await onApiCallPropertyDetails(data);
      setProfileData(response);


    } catch (err) {
      console.error("Error fetching property list:", err);
    }
  };

  // Update handleSubAmenities to accept amenities as parameter
  const handleSubAmenities = async (amenitiesArray) => {
    try {
      if (!amenitiesArray || amenitiesArray.length === 0) return;

      const data = amenitiesArray;
      const params = `?lang=${lang}`
      const response = await onApiCallSubAmenities(data, params);
      setSubAmenities(response);
    } catch (err) {
      console.error("Error fetching sub-amenities:", err);
    }
  };



  const [selectedDateIndex, setSelectedDateIndex] = useState(1);
  const [time, setTime] = useState("");
  const [mode, setMode] = useState("inperson");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [captchaToken, setCaptchaToken] = useState(null);
  const [open, setOpen] = useState(false);


  const faqs = [
    {
      question: "How do I book a visit?",
      answer: "Click the Request a Visit button and choose your preferred time. Our team will confirm the appointment shortly."
    },
    {
      question: "How do I apply for this unit?",
      answer: "Press the Apply Now button, and we’ll send you a secure application link through our screening partner (Trustii, SingleKey, etc.)."
    },
    {
      question: "What documents do I need?",
      answer: "You’ll typically need basic ID, proof of income, and your employment details. The application link will tell you exactly what to upload."
    }
  ];
  const [activeIndex, setActiveIndex] = useState(0);
  const [showShareMenu, setShowShareMenu] = useState(false);


  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const generateDates = (count) => {
    const result = [];
    const today = new Date();

    for (let i = 0; i < count; i++) {
      const d = new Date();
      d.setDate(today.getDate() + i);

      result.push({
        day: d.toLocaleDateString("en-US", { weekday: "short" }),
        date: d.getDate().toString().padStart(2, "0"),
        month: d.toLocaleDateString("en-US", { month: "short" }),
      });
    }

    return result;
  };


  const navigator = useNavigate();

  const onSend = async (e) => {
    e.preventDefault();
    const payload = {
      property_id: Number(id),
      date: value,
      name,
      time,
      email,
      phone,
      captchaToken,
    };
    const params = `/?lang=${lang}`
    try {
      const res = await onApiCallBookingSend(payload, params);
      setSelectedDateIndex(0);
      setTime("");
      setMode("");
      setName("");
      setEmail("");
      setPhone("");
      setMessage("");
      setCaptchaToken(null)
      toast.success(res?.message || "Send successful");
    } catch (error) {
      console.error("Booking send failed:", error);
      alert("Failed to send booking ❌");
    }

  };

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -120, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 120, behavior: "smooth" });
    }
  };
  const formatPrice = (value) => {
    if (!value) return "";
    return Number(value).toLocaleString("en-US");
  };

  const [propertyPrev, setPropertyPrev] = useState()
  const [propertyNext, setPropertyNext] = useState();

  const handleApiCallPropertyPrev = async () => {
    try {
      const data = {
        id: id
      }
      const params = `/?lang=${lang}`

      const res = await onApiCallPropertyPrev(data, params);
      console.log("Prev response:", res);
      setPropertyPrev(res?.data)

    } catch (err) {
      console.error(err);
    }
  }

  const handleApiCallPropertyNext = async () => {
    try {

      const data = {
        id: id
      }
      const params = `/?lang=${lang}`
      const res = await onApiCallPropertyNext(data, params);
      setPropertyNext(res.data);

      console.log("Next response:", res);
    } catch (err) {
      console.error(err);
    }

  }

  useEffect(() => {
    handleApiCallPropertyPrev();
    handleApiCallPropertyNext();
    handleApiCallPropertyList();

  }, [lang]);

  useEffect(() => {
    if (profileData) {
      if (profileData.amenities && profileData.amenities.length > 0) {
        handleSubAmenities(profileData.amenities);
      }
    }
  }, [lang, profileData]);

  const shareUrl = `https://unityleases.ca/properties/properties-details/${id}`;

  const { t } = useTranslation();

  return (
    <div className="pd-page" style={{ padding: "0px", paddingBottom: "30px" }} >

      {/* <div>
        <div className="nav-prev" onClick={() => {
          navigator(`/properties/properties-details/${propertyPrev?.id}`)
          window.location.reload();
          handleApiCallPropertyList()
        }
        }>
          <span className="nav-text">{propertyPrev?.title}</span>
          <svg width="20" height="20" viewBox="0 0 20 20"><path d="M12 4L6 10L12 16" stroke="" stroke-width="2" fill="none"></path></svg>
        </div>

        <div className="nav-next" onClick={() => {
          navigator(`/properties/properties-details/${propertyNext?.id}`)
          window.location.reload();
          handleApiCallPropertyList()
        }
        }
        >
          <svg width="20" height="20" viewBox="0 0 20 20"><path d="M8 4L14 10L8 16" stroke="" stroke-width="2" fill="none"></path></svg>
          {propertyNext && <span className="nav-text">{propertyNext.title}</span>}
        </div>
      </div> */}

      <PropertySlider profileData={profileData} />
      <div className="container">

        <div className="pd-top-row">
          {/* <div className="pd-badges">
            <span className="pd-badge"> {profileData?.type}</span>
            <span className="pd-badge dark">{profileData.property_type}</span>
          </div> */}


        </div>




        <div className="pd-grid" style={{ paddingBottom: "30px" }}>
          {/* LEFT COLUMN */}
          <main className="pd-left">
            <h1 className="pd-title pr-title" style={{ textTransform: "capitalize" }} >{profileData?.title}</h1>
            {profileData.living && <>
              <div className="pd-sub"><i class="fas fa-map-marker-alt"></i> {profileData?.address}</div>
            </>}
            <div style={{ marginTop: "10px", marginBottom: "20px", color: "#555", display: "flex", gap: "10px", alignItems: "center" }}>

              <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {/* Bedroom Icon */}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(85, 85, 85)" strokeWidth="2">
                  <path d="M3 7v10"></path>
                  <path d="M21 7v10"></path>
                  <path d="M3 12h18"></path>
                  <path d="M7 12V9a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v3"></path>
                </svg>
                {profileData.bedrooms} {t("Bedrooms")}
              </span>

              <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                {/* Bathroom Icon */}
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(85, 85, 85)" strokeWidth="2">
                  <path d="M4 4h16"></path>
                  <path d="M10 4v2"></path>
                  <path d="M14 4v2"></path>
                  <path d="M8 10h8"></path>
                  <path d="M12 12v6"></path>
                  <circle cx="12" cy="20" r="1"></circle>
                </svg>
                {profileData.bathrooms}  {t("Bathrooms")}
              </span>

            </div>
            <section className="pd-card">
              <h3 className="pd-card-title">{t("Overview")}</h3>
              <p className="pd-card-body"
                dangerouslySetInnerHTML={{ __html: profileData?.description || "" }}>
              </p>
            </section>
            {profileData.living && (
              <section
                className="pd-card"
                style={{
                  border: "1px solid #0c4a6e",
                  padding: "20px",
                  borderRadius: "10px",
                  marginTop: "20px",
                }}
              >
                <h4
                  className="pd-card-title"
                >
                  {t("Location Details")}
                </h4>

                <div className="pd-address-grid">

                  {/* LEFT COLUMN */}
                  {profileData?.street_address && (
                    <div className="pd-address" style={{ width: "45%" }}>
                      <strong>{t("Street Address:")}</strong> {profileData.street_address}
                    </div>
                  )}

                  {profileData?.nearby_metro && (
                    <div className="pd-address" style={{ width: "45%" }}>
                      <strong>{t("Nearest Metro:")}</strong> {profileData.nearby_metro}
                    </div>
                  )}

                  {/* RIGHT COLUMN */}
                  {profileData?.neighborhood && (
                    <div className="pd-address" style={{ width: "45%" }}>
                      <strong>{t("Neighborhood: ")}</strong> {profileData.neighborhood}
                    </div>
                  )}

                  {profileData?.nearby_grocery && (
                    <div className="pd-address" style={{ width: "45%" }}>
                      <strong>{t("Nearby Grocery:")}</strong> {profileData.nearby_grocery}
                    </div>
                  )}

                </div>
              </section>
            )}

            <section className="pd-card ">
              <h4 className="pd-card-title">{t("Unit Specifications")}
              </h4>
              <div className="pd-address-grid">
                <div className="pd-address" style={{ width: "45%" }}><strong>{t("Bedrooms")}:</strong><div>{profileData?.bedrooms}</div></div>
                <div className="pd-address" style={{ width: "45%" }}><strong>{t("Bathrooms")}:</strong><div>{profileData?.bathrooms}</div></div>
                <div className="pd-address" style={{ width: "45%" }}><strong>{t("Size")}:</strong><div>{profileData?.size}</div></div>
                <div className="pd-address" style={{ width: "45%" }} ><strong>
                  {t("Price range")}:</strong><div>{t("from")}
                    {profileData.price_monthly_up ? (
                      profileData.price_monthly_down && Number(profileData.price_monthly_down) !== 0 ? (
                        ` $${formatPrice(profileData.price_monthly_down)}-$${formatPrice(profileData.price_monthly_up)}`
                      ) : (
                        `$${formatPrice(profileData.price_monthly_up)}+`
                      )
                    ) : (
                      ""
                    )} / {t("month")}</div></div>
                <div className="pd-address" style={{ width: "45%" }}><strong>{t("Availability")}:</strong><div>{profileData?.availability}</div></div>

              </div>

            </section>
            <section className="pd-card">
              <h4 className="pd-card-title">{t("Included Features")}</h4>

              {subAmenities && subAmenities.length > 0 &&
                Object.entries(
                  subAmenities.reduce((acc, item) => {
                    const parentName = item.parent_amenity.name;
                    if (!acc[parentName]) acc[parentName] = [];
                    acc[parentName].push(item); // push full object, not only name
                    return acc;
                  }, {})
                ).map(([parentName, items], index) => (
                  <div key={index}>
                    {/* Parent Amenity Title */}
                    <div className="pd-amenities">{parentName}</div>

                    {/* Items Grid */}
                    <div className="pd-address-grid">
                      {items.map((item, idx) => (
                        <div
                          key={idx}
                          className="pd-address"
                          style={{ width: "45%", display: "flex", alignItems: "center" }}
                        >
                          {item.icons ? (
                            <img
                              src={UrlImage + item.icons}
                              alt="check-icon"
                              width={20}
                              style={{ marginRight: "6px" }}
                            />
                          ) : (
                            <strong style={{ color: "#1f2b4a", marginRight: "6px" }}>
                              <i className="far fa-check-circle"></i>
                            </strong>
                          )}

                          <div>{item.name}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              }

            </section>

            <section className="pd-card" style={{ border: "none" }} >
              <h4 className="pd-card-title">{t("Questions & Answers")}</h4>
              <div className="accordion" id="faqAccordion">
                {faqs.map((faq, index) => (
                  <div className="accordion-item" key={index}>
                    <div
                      className={`accordion-header ${activeIndex === index ? "active" : ""}`}
                      onClick={() => toggleAccordion(index)}
                    >
                      {t(faq.question)}
                      <span className="arrow">{activeIndex === index ? "▲" : "▼"}</span>
                    </div>
                    <div
                      className={`accordion-body ${activeIndex === index ? "open" : ""}`}
                    >
                      <p>{t(faq.answer)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

          </main>

          {/* RIGHT SIDEBAR */}
          <div className="pd-right sticky" style={{ position: 'relative' }} onMouseLeave={() => setShowShareMenu(false)}>
            <div className="pd-price" style={{ marginBottom: "20px" }}>
              <div className="pd-price-small">{t("from")}</div>
              <div className="pd-price-big">
                <span className="pd-number">
                  {profileData.price_monthly_up ? (
                    profileData.price_monthly_down && Number(profileData.price_monthly_down) !== 0 ? (
                      `$${formatPrice(profileData.price_monthly_down)}-$${formatPrice(profileData.price_monthly_up)}`
                    ) : (
                      `$${formatPrice(profileData.price_monthly_up)}+`
                    )
                  ) : (
                    ""
                  )}</span>
                <span className="pd-suffix">/ {t("month")}</span>
              </div>
            </div>
            <div className="pd-booking-card" style={{ marginBottom: "20px", padding: "0px 0px", border: "none" }}>
              <div className="pd-contact-agent">
                <Link to="/properties/ApplicationToLease"> {t("Apply Now")}</Link>
                <a
                  onClick={() => setOpen(true)}
                  style={{
                    marginTop: "20px",
                    border: "2px solid #1F5C8A",
                    textBox: "none",
                    color: "#1F5C8A",
                    backgroundColor: "white",
                  }} > {t("Request A  Visit")}</a>
              </div>
            </div>

            <form className="pd-booking-card" onSubmit={onSend}>
              <div className="pd-time-date">
                <div className="pd-booking-top">

                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      open={openPicker}
                      onOpen={() => setOpenPicker(true)}
                      onClose={() => setOpenPicker(false)}
                      value={value}
                      onChange={(newValue) => {
                        setValue(newValue);
                        setOpenPicker(false);
                      }}
                      inputFormat="dd MMM yyyy"
                      // use slotProps to control the underlying TextField (MUI v5 DatePicker)
                      slotProps={{
                        textField: {
                          // important: make the placeholder visible and style the TextField like a button
                          placeholder: t ? t("move_in_date") : "Move-in Date",
                          onClick: (e) => {
                            e.stopPropagation();
                            setOpenPicker(true);
                          },
                          // make input readOnly if you want to force use of picker (optional)
                          InputProps: {
                            readOnly: true,
                          },
                          sx: {
                            // pill/button look
                            backgroundColor: "#1F5C8A", // the blue color
                            color: "#ffffff",
                            borderRadius: "8px",
                            // remove the default outline
                            "& .MuiOutlinedInput-notchedOutline": {
                              border: "none",
                            },
                            // placeholder color
                            "& input::placeholder": {
                              color: "#ffffff",
                              opacity: 1,
                            },
                            // ensure text content white
                            "& .MuiInputBase-input": {
                              color: "#ffffff",
                              fontWeight: 600,
                              padding: "10px 18px",
                            },
                            // label removal / layout fixes (in case MUI injected a label)
                            "& .MuiFormLabel-root": { display: "none" },
                            minWidth: 180,
                          },
                          variant: "outlined",
                        },
                      }}
                    />
                  </LocalizationProvider>
                </div>

                <div className="time-dyam-dp" >
                  <DynamicTimeSelect
                    start="10:00"
                    end="20:30"
                    step={30}
                    value={time}
                    onChange={(v) => setTime(v)}
                    placeholder={t("Select Time")}
                    className="your-custom-class"
                  />
                </div>
              </div>

              <div className="pd-form-group">
                <label>
                  {t("Your information")}

                </label>
                <input type="text" value={name} placeholder={t("Your Name")} onChange={(e) => setName(e.target.value)} required />
                <input type="email" placeholder={t("Your Email")} value={email} onChange={(e) => setEmail(e.target.value)} required />
                <input type="text" value={phone} placeholder={t("Your Phone")} onChange={(e) => setPhone(e.target.value)} />
              </div>
              <ReCAPTCHA
                sitekey={sitekey}
                onChange={(token) => setCaptchaToken(token)}
              />

              <button type="submit" className="pd-submit">{t("Send Email")}</button>
            </form>



          </div>
        </div>
        {profileData.living && <>

          <section className="pd-card " id="map">
            <h4 className="pd-card-title">{t("Map")}
            </h4>
            <div className="pd-map-wrapper" >
              {profileData?.lat && profileData?.lng && (
                <iframe
                  title="property-map"
                  width="100%"
                  height="300"
                  frameBorder="0"
                  style={{ border: 0, borderRadius: "10px" }}
                  src={`https://www.google.com/maps?q=${profileData.lat},${profileData.lng}&hl=en&z=14&output=embed`}
                  allowFullScreen
                ></iframe>
              )}

            </div>
          </section ></>}

        <section className="pd-similar">
          <SimilarListings id={id} />

        </section>
      </div>
      <VisitModal
        open={open}
        onClose={() => setOpen(false)}
        profileData={profileData}
        initialUnit={profileData?.bedrooms && profileData?.bathrooms ? `${profileData.bedrooms} ${t("Bed")} ${profileData.bathrooms} ${t("Bath")}  ${profileData.address} ` : ""}
      />
    </div>
  );
};

export default PropertyDetails;
